import QRCode from 'qrcode';
import { useEffect, useState, useCallback } from 'react';
import { useLocalStorage, useMountedState } from 'react-use';

import { handleError } from '@mssgme/lib';

export function useQRCode(data, options) {
    const isMounted = useMountedState();
    const [base64Url, setBase64Url] = useState();

    useEffect(() => {
        async function generateQRCode() {
            try {
                const res = await QRCode.toDataURL(data, options);

                if (isMounted()) {
                    setBase64Url(res);
                }
            } catch (error) {
                handleError(error);
            }
        }

        generateQRCode();
    }, [data, options]);

    return base64Url;
}

export function useExpired(key, days) {
    const [expired, setExpired] = useLocalStorage(key, 0);
    const isExpired = Date.now() >= expired;

    const renew = useCallback(() => {
        setExpired(Date.now() + 864e5 * days);
    }, [days]);

    return [isExpired, renew];
}
